import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";

import uiReducerMixin from "./reducers/ui";
import countryCodeReducerMixin from "./reducers/countryCode";
import routingReducerMixin from "./reducers/routing";
import domainsReducerMixin from "./reducers/domains";
import getCartReducerMixin from "./reducers/cart";
import getProductsReducerMixin from "./reducers/products";
import modalMixin from "./reducers/modal";
import onecomConfigReducerMixin from "./reducers/onecomConfig";
import customerInformationMixin from "./reducers/customerInformation";

export default function configureStore(serviceLocator, initialState) {
  const rootReducer = combineReducers({
    ...uiReducerMixin,
    ...routingReducerMixin,
    ...domainsReducerMixin,
    ...getCartReducerMixin,
    ...getProductsReducerMixin,
    ...modalMixin,
    ...countryCodeReducerMixin,
    ...onecomConfigReducerMixin,
    ...customerInformationMixin,
  });

  const logger = createLogger({
    collapsed: true,
  });

  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(thunk.withExtraArgument(serviceLocator), logger),
  );
}
